import * as Yup from 'yup';
import { DictionaryEPrtrActivity } from '../../models';

export function useValidationSchema() {
  return Yup.object<DictionaryEPrtrActivity>().shape({
    name: Yup.string().nullable().required('Povinné pole'),
    code: Yup.string().nullable().required('Povinné pole'),
  });
}
